<div class="eau-leading-bid eau-bidding-status-component clearfix">
    <div class="eau-bidding-status-component--title" data-qa="leftMenuLeadingBidText">{{'bidding_status.leading_bid' | translate}}</div>
    <div class="eau-bidding-status-component--content" data-qa="leftMenuLeadingBidvalue" [class.eau-is-shaked]="isAnimated">
        {{getLeadingBid()}}
    </div>
</div>
